"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tabsStyle = exports.tabStyle = void 0;
var _colors = require("../colors.config");
var _helpers = require("../../components/utils/helpers");
var TaskCompleteIcon = (0, _helpers.getImageByAgent)('task-complete.svg');
var tabStyle = function tabStyle(isFontBigger, isHighContrast) {
  return {
    root: {
      '&.complete': {
        '& .MuiTab-wrapper': {
          color: _helpers.agentDeveloperUtils.getSecondaryColor(300)
        },
        '& .MuiTab-wrapper:before': {
          backgroundColor: _helpers.agentDeveloperUtils.getPrimaryColor(450),
          backgroundRepeat: 'no-repeat',
          content: '""',
          height: '16px',
          left: '5px',
          // backgroundImage: `url(${TaskCompleteIcon})`,
          // -webkit-mask-image: url(TaskCompleteIcon);
          // mask-image: url(TaskCompleteIcon);
          mask: "url(".concat(TaskCompleteIcon, ") no-repeat 50% 50%"),
          position: 'absolute',
          top: '50%',
          transform: 'translate(50%, -50%)',
          webkitMaskImage: "url(".concat(TaskCompleteIcon, ") no-repeat 50% 50%"),
          width: '17px'
        },
        backgroundColor: _colors.Black[20],
        fontSize: isFontBigger ? '23px' : '20px',
        fontWeight: 'bold',
        position: 'relative'
      },
      '&.Mui-selected': {
        '& .MuiTab-wrapper': {
          color: 'white'
        },
        backgroundColor: _helpers.agentDeveloperUtils.getSecondaryColor(300),
        fontSize: isFontBigger ? '23px' : '20px',
        fontWeight: 'bold'
      },
      '&.Mui-selected>.MuiTab-wrapper>h1': {
        fontSize: isFontBigger ? '23px' : '20px'
      },
      borderBottomRightRadius: '25px',
      borderTopRightRadius: '25px',
      fontSize: isFontBigger ? '20px' : '16px',
      fontWeight: 'normal',
      height: '51px',
      marginBottom: '10px',
      opacity: 1,
      textAlign: 'left',
      transition: 'all 0.5s'
    },
    textColorInherit: {
      '& .MuiTab-wrapper': {
        color: isHighContrast ? _helpers.agentDeveloperUtils.getSecondaryColor(195) : _helpers.agentDeveloperUtils.getSecondaryColor(300)
      },
      '&.Mui-disabled': {
        '& .MuiTab-wrapper': {
          color: isHighContrast ? _helpers.agentDeveloperUtils.getSecondaryColor(170) : _helpers.agentDeveloperUtils.getSecondaryColor(300)
        },
        opacity: 1
      },
      '&.Mui-disabled.Mui-selected': {
        '& .MuiTab-wrapper': {
          color: _colors.Black[10]
        },
        opacity: 1
      },
      opacity: 1
    },
    wrapper: {
      alignItems: 'flex-start',
      color: _helpers.agentDeveloperUtils.getSecondaryColor(300),
      opacity: 1,
      paddingLeft: '30px',
      paddingRight: '30px'
    }
  };
};
exports.tabStyle = tabStyle;
var tabsStyle = exports.tabsStyle = {
  root: {
    '& .MuiTabs-indicator': {
      display: 'none'
    },
    width: '100%'
  }
};